import { render, staticRenderFns } from "./gdpr.vue?vue&type=template&id=2b06423b&scoped=true"
import script from "./gdpr.vue?vue&type=script&lang=js"
export * from "./gdpr.vue?vue&type=script&lang=js"
import style0 from "./gdpr.vue?vue&type=style&index=0&id=2b06423b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06423b",
  null
  
)

export default component.exports